var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.6 330.5m-176.6 0a176.6 176.6 0 1 0 353.2 0 176.6 176.6 0 1 0-353.2 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M491.2 517.1H352.4C191.7 517.1 61.5 647.3 61.5 808c0 48.5 39.4 87.9 87.9 87.9h528.2c38.1 0 69-30.9 69-69v-54.4c0-141-114.4-255.4-255.4-255.4zM605.8 329.1c0 46.7-17 89.4-45.2 122.3-3.3 3.8-3.1 9.5 0.4 13.2 24.4 25.3 58.7 41 96.6 41 74.6 0 135-60.7 134.5-135.4-0.5-73-59.9-132.7-132.9-133.5-20.6-0.2-40.1 4.1-57.6 12.2-6.2 2.9-9.3 10-7 16.4 7.3 19.8 11.2 41.3 11.2 63.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M681.8 527.5H643c-7.9 0-10.8 10.4-4 14.5 77.3 45.9 129.1 130.2 129.1 226.7v56.1c0 15.1-4.7 29.1-12.8 40.7-3.6 5.1 0 12.2 6.3 12.2H854c35.2 0 63.8-28.6 63.8-63.8v-50.2c0-130.5-105.7-236.2-236-236.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d28da92f6bbb14cfa8e4761697f223c6.svg";
export { ForwardRef as ReactComponent };